import React from 'react';
const StorySection = () => {
  return <div className="w-full bg-gray-700 text-white py-16 px-4" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-189">
          Moment w którym zaczęłam dostrzegać prawdę
        </h2>
        <div className="mb-8" data-id="element-190">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m3uUQENSasw9w3fREbq5Dt/14.png" alt="Kobieta patrząca w walizkę syna" className="w-full rounded-lg shadow-lg" data-id="element-191" />
        </div>
        <p className="text-lg mb-6" data-id="element-192">
          Siedziałam w pokoju mojego syna i patrzyłam na jego walizkę.
        </p>
        <p className="text-lg mb-6" data-id="element-193">
          "Mamo, jadę na ten gap year. Muszę coś ze sobą zrobić" – powiedział
          wczoraj przy kolacji. Córka kiwnęła głową, jakby to było oczywiste.
          "Ja też myślę o przeprowadzce do Warszawy. Tu nie ma dla mnie
          przyszłości."
        </p>
        <p className="text-lg mb-6" data-id="element-194">
          A ja? Siedziałam między nimi jak zahipnotyzowana. Moja 82-letnia mama
          z pokoju obok zawołała po raz piąty tego wieczoru: "Kasiu! Chodź tu!
          Coś mi się wydaje!"
        </p>
        <p className="text-lg mb-6" data-id="element-195">
          Wszyscy mają plany. Wszyscy wiedzą, dokąd idą. Tylko ja tkwię w
          miejscu, jakby ktoś mi nogi zalał betonem.
        </p>
        <p className="text-xl font-bold mb-6 italic" data-id="element-196">
          Czy ty też czujesz się jak widmo we własnym życiu?
        </p>
        <div className="w-full h-px bg-gray-500 my-10" data-id="element-197"></div>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rTDjeE9W7nRzLcuu4siDcS/13.png" alt="Kobieta z pokolenia kanapkowego" className="w-full h-auto object-cover rounded-lg mb-8 shadow-lg" data-id="element-198" />
      </div>
    </div>;
};
export default StorySection;